import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {

  @Input() loadingText:string = "Please wait while loading.";
  @Input() smallSpinner:boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

}
